function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Button from './Button';
import { Input } from './Input';
import { TypeWriterAnimation } from './TypeWriterAnimation';
const ConversationStep = _ref => {
  let {
    animationsEnabled,
    conversation,
    externalStyles,
    handleSelectConversationStep
  } = _ref;
  const {
    conversationContainerStyle,
    textContainerStyle,
    textStyle,
    formStyle,
    inputContainerStyle,
    inputStyle,
    buttons
  } = externalStyles || {};
  const [inputValue, setInputValue] = useState('');
  const [canShowReplies, setCanShowReplies] = useState(false);
  function handleChangeInputValue(text) {
    setInputValue(text);
  }
  function handleSubmitInputValue() {
    handleSelectConversationStep(inputValue ? inputValue.trim() : ' ');
    setInputValue('');
    setCanShowReplies(false);
  }
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.container, conversationContainerStyle]
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.textContainer, textContainerStyle]
  }, /*#__PURE__*/React.createElement(TypeWriterAnimation, {
    textStyle: textStyle,
    message: conversation.messages.join('º'),
    doneAnimatingText: setCanShowReplies,
    hasAnimation: animationsEnabled
  })), /*#__PURE__*/React.createElement(View, {
    style: styles.innerContainer
  }, conversation.buttons.length === 0 && conversation.state !== 'ENDED' && canShowReplies && /*#__PURE__*/React.createElement(View, {
    style: [styles.form, formStyle]
  }, /*#__PURE__*/React.createElement(Input, {
    inputContainerStyle: inputContainerStyle,
    inputStyle: inputStyle,
    onChangeText: handleChangeInputValue,
    value: inputValue,
    placeholder: "Enter your message",
    keyboardType: "default",
    autoFocus: true,
    onSubmitEditing: e => {
      if (e.nativeEvent.key === 'Enter') {
        handleSubmitInputValue();
      }
    }
  }), /*#__PURE__*/React.createElement(Button, _extends({
    label: "Send",
    handlePress: () => handleSubmitInputValue()
  }, buttons?.send || {}))), canShowReplies && conversation.buttons.map((text, i) => {
    return /*#__PURE__*/React.createElement(Button, _extends({
      label: text,
      key: `button_${i}`,
      handlePress: () => handleSelectConversationStep(text)
    }, buttons?.chip || {}));
  })));
};
const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignSelf: 'stretch',
    maxWidth: 1024,
    marginTop: 32
  },
  textContainer: {
    alignSelf: 'stretch'
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 64,
    marginTop: 32
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  restartButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 64,
    marginTop: 32
  }
});
export default ConversationStep;
//# sourceMappingURL=ConversationStep.js.map